<template>
  <nav>
    <router-link to="/">Home</router-link>
    <router-link to="/games">Games</router-link>
    <router-link to="/about">About</router-link>
  </nav>
</template>

<script>
export default {
  name: 'Nav'
}
</script>

<style scoped></style>
